<template>
  <div class="ad_music_popup modal">
    <div class="ad_music_box modal_box">
      <div class="ad_music_title modal_title">
        <h2>브랜드 음원 등록</h2>
        <div class="modal_close_btn" @click="$emit('closeAddModal')">
          <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 7.55012L16.0003 0.549805L18 2.54949L10.9997 9.5498L18 16.5501L16.0003 18.5498L9 11.5495L1.99969 18.5498L0 16.5501L7.00031 9.5498L0 2.54949L1.99969 0.549805L9 7.55012Z" fill="white"/>
          </svg>
        </div>
      </div>
      <div>
        <label>브랜드 선택</label>
        <div class="select-box-area">
          <div class="label select-box" @mouseover.once="clickSelectBox">
            {{ brandName }}
          </div>
          <div class="select-box-dropDown">
            <ul class="optionList">
              <li class="optionItem" v-for="item, i in brandList" :key="i" @click="selectBrand(item.brandId)"><p v-html="item.brandNm" /><img src="/media/img/space_check_none.png"></li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <label>브랜드 음원명</label>
        <input type="text" name="brandMusicNm" maxlength="20" placeholder="브랜드 음원명을 20자 내로 입력해주세요." v-model="brandMusicNm">
        <p class="name_count">{{ brandMusicNm.length }}<span> / 20</span></p>
      </div>
      <div>
        <p>브랜드 음원 파일</p>
        <div v-show="fileName === ''" @click="fileUpload" class="file-upload" :class="isDragged ? 'dragged' : ''" @dragover="onDragover" @dragleave="onDragleave" @drop="onDrop">
          <img src="/media/img/Icon_mp3_52_52.svg" alt="">
          <p>클릭하거나 드래그로 파일을 업로드하세요.</p>
          <input type="file" accept=".mp3,.wav" id="file" class="file" name="multipartFile" @change="checkName" style="display: none;">
        </div>
        <div class="upload-file" v-show="fileName !== ''" style=" flex-direction:row;">
          <p>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.3566 4.9644L5.64325 9.67857C5.56365 9.75544 5.50017 9.84739 5.4565 9.94906C5.41282 10.0507 5.38983 10.1601 5.38887 10.2707C5.38791 10.3814 5.40899 10.4911 5.45089 10.5935C5.4928 10.6959 5.55467 10.789 5.63292 10.8672C5.71116 10.9455 5.8042 11.0073 5.90662 11.0493C6.00903 11.0912 6.11876 11.1122 6.22941 11.1113C6.34006 11.1103 6.44941 11.0873 6.55108 11.0436C6.65275 11 6.74471 10.9365 6.82158 10.8569L11.5357 6.14357C12.0046 5.67468 12.268 5.03875 12.268 4.37565C12.268 3.71255 12.0046 3.07661 11.5357 2.60773C11.0669 2.13885 10.4309 1.87544 9.76783 1.87544C9.10473 1.87544 8.46879 2.13885 7.99991 2.60773L3.28575 7.3219C2.89081 7.70701 2.57627 8.1667 2.36038 8.67431C2.14448 9.18193 2.03153 9.72736 2.02808 10.279C2.02462 10.8306 2.13073 11.3774 2.34024 11.8877C2.54976 12.3979 2.85851 12.8615 3.24859 13.2516C3.63867 13.6416 4.10232 13.9503 4.61262 14.1597C5.12293 14.3692 5.66975 14.4752 6.22136 14.4717C6.77296 14.4681 7.31838 14.3551 7.82596 14.1391C8.33355 13.9232 8.79319 13.6086 9.17825 13.2136L13.8924 8.50023L15.0707 9.67857L10.3566 14.3927C9.81488 14.9344 9.17178 15.3641 8.46401 15.6573C7.75624 15.9505 6.99766 16.1014 6.23158 16.1014C5.4655 16.1014 4.70691 15.9505 3.99915 15.6573C3.29138 15.3641 2.64828 14.9344 2.10658 14.3927C1.56488 13.851 1.13518 13.2079 0.842008 12.5002C0.54884 11.7924 0.397949 11.0338 0.397949 10.2677C0.397949 9.50165 0.54884 8.74307 0.842008 8.0353C1.13518 7.32753 1.56488 6.68443 2.10658 6.14273L6.82158 1.4294C7.60742 0.670407 8.65993 0.25043 9.75242 0.259923C10.8449 0.269417 11.89 0.707621 12.6625 1.48015C13.435 2.25269 13.8732 3.29774 13.8827 4.39023C13.8922 5.48271 13.4722 6.53522 12.7132 7.32107L7.99991 12.0369C7.76769 12.2691 7.49202 12.4532 7.18863 12.5788C6.88524 12.7045 6.56007 12.7691 6.2317 12.7691C5.90333 12.769 5.57818 12.7043 5.27482 12.5786C4.97146 12.4529 4.69583 12.2687 4.46366 12.0365C4.2315 11.8043 4.04734 11.5286 3.92172 11.2252C3.79609 10.9218 3.73145 10.5966 3.73149 10.2683C3.73153 9.9399 3.79624 9.61475 3.92194 9.31139C4.04764 9.00803 4.23186 8.7324 4.46408 8.50023L9.17825 3.78607L10.3566 4.9644Z" fill="white"/>
            </svg>
            {{ fileName }}
          </p>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" @click="cancelFile">
            <path d="M6.0001 4.80029L10.2003 0.600098L11.4001 1.79991L7.19991 6.0001L11.4001 10.2003L10.2003 11.4001L6.0001 7.19991L1.79991 11.4001L0.600098 10.2003L4.80029 6.0001L0.600098 1.79991L1.79991 0.600098L6.0001 4.80029Z" fill="white"/>
          </svg>
        </div>
        <p class="alert_mp3" v-if="alertCheckFile">MP3 또는 WAV파일만 등록 가능합니다.</p>
        <p class="alert_mp3" v-if="alertCheckSpacing">파일명에 공백이 존재하지 않아야합니다.</p>
        <p class="alert_mp3" v-if="alertCheckName">이미 등록된 브랜드 음원명입니다.</p>
        <p class="alert_mp3" v-if="alertCheckMaxSize">파일은 최대 5MB까지만 업로드 가능합니다.</p>
      </div>
      <div class="music_notice">
        <p><span></span>MP3, WAV 파일만 등록 가능합니다.</p>
        <p><span></span>5MB 이하의 파일만 업로드 가능합니다.</p>
        <p><span></span>파일명을 공백 없이 작성해주세요.</p>
      </div>
      <div class="btn_area">
        <p></p>
        <div>
          <div class="btn_style close_btn" @click="$emit('closeAddModal')">
            <p>취소</p>
          </div>
          <div class="btn_style" @click="InsertMusic">
            <p>등록</p>
          </div>
        </div>
      </div>

      <Loading v-if="loadingStatus"></Loading>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/modal/common/Loading.vue';
import VueCookies from "vue-cookies";
import axios from "@/service/axios";
import $ from 'jquery';

export default {
  name: 'insertMusic',

  props: {
    brandList: Array,
    name: String
  },

  components: {
    Loading
  },

  data () {
    return {
      brandId: '',
      brandName: '',

      //브랜드 음원명
      brandMusicNm: '',

      //파일
      file: null,
      fileName: '',

      //alert
      alertCheckFile: false,
      alertCheckSpacing: false,
      alertCheckName: false,
      alertCheckMaxSize: false,

      //드래그
      isDragged: false,

      //로딩
      loadingStatus: false
    };
  },

  mounted () {
    this.brandId = VueCookies.get('brandId');
    this.brandName = this.name;
  },

  methods: {
    onDragenter () {
      // class 넣기
      this.isDragged = true
    },

    onDragleave () {
      // class 삭제
      this.isDragged = false
    },

    onDragover (event) {
      // 드롭을 허용하도록 prevetDefault() 호출
      event.preventDefault()
    },

    onDrop (event) {
      // 기본 액션을 막음 (링크 열기같은 것들)
      event.preventDefault()
      this.isDragged = false;
      this.file = event.dataTransfer.files[0];
      const fileNm = this.file.name;
      const fileDir = fileNm.substring(fileNm.lastIndexOf("/") + 1, fileNm.length);
      const fileSize = this.file.size;
      this.setName(fileDir, fileSize);
    },

    fileUpload () {
      $('.file').click();
    },

    checkName () {
      this.file = document.getElementsByName('multipartFile')[0].files[0];
      const fileDir = this.file.name;
      const fileSize = this.file.size;
      this.setName(fileDir, fileSize);
    },

    setName (fileDir, fileSize) {
      //파일명 공백 체크
      if (fileDir.search(' ') === -1) {
        const file = fileDir.substring(fileDir.lastIndexOf(".") + 1, fileDir.length);

        //파일 확장자 체크
        if (file.toLowerCase().search('mp3') === -1 && file.toLowerCase().search('wav') === -1) {
          //파일 확장자가 .mp3나 .wav가 아닐 경우
          this.file = null;
          this.alertCheckFile = true;
        } else {
          //파일 사이즈 체크
          if ((1024 ** 2 * 5) < fileSize) {
            //파일 사이즈가 5MB를 초과할 경우
            this.file = null;
            this.alertCheckMaxSize = true;
            this.alertCheckFile = false;
            this.alertCheckSpacing = false;
          } else {
            this.fileName = fileDir;
            this.alertCheckFile = false;
            this.alertCheckSpacing = false;
            this.alertCheckMaxSize = false;
          }
        }
      } else {
        //파일명에 공백이 있을 경우
        this.file = null;
        this.alertCheckFile = false;
        this.alertCheckSpacing = true;
      }
    },

    cancelFile () {
      this.file = null;
      this.fileName = '';
      document.getElementById('file').value = '';
    },

    /**
     * * 브랜드 음원 등록
     */
    InsertMusic () {
      this.loadingStatus = true;
      const formdata = new FormData();
      const brandId = this.brandId;
      const brandMusicNm = this.brandMusicNm;
      const brandOriginalNm = this.fileName;
      const multipartFile = this.file;
      const aToken = VueCookies.get("aToken");
      const headers = { "X-AUTH-TOKEN": aToken, 'Content-Type':'multipart/form-data' };

      if (brandMusicNm === '') {
        this.loadingStatus = false;
        alert('음원명을 입력해주세요.');
        return false;
      }

      if (multipartFile == null && multipartFile === undefined) {
        this.loadingStatus = false;
        alert('파일을 등록해주세요.');
        return false;
      }

      formdata.append('brandId', brandId);
      formdata.append('brandMusicNm', brandMusicNm);
      formdata.append('brandOriginalNm', brandOriginalNm);
      formdata.append('multipartFile', multipartFile);

      axios
        .post('/api/brand/insertBrandMusic', formdata, { headers })
        .then(res => {
          if (res.data.result) {
            this.$emit('getList');
          } else {
            this.alertCheckName = true;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadingStatus = false;
        })
    },

    selectBrand (index) {
      this.brandId = index;
    },

    clickSelectBox () {
      /*select_box_custom*/
      var label = document.querySelectorAll('.label');
      label.forEach(function (lb) {
        lb.addEventListener('click', () => {
          var optionList = lb.nextElementSibling;
          var optionItems = optionList.querySelectorAll('.optionItem');
          clickLabel(lb, optionItems);
        });
      });
      var clickLabel = (lb, optionItems) => {
        //****************** 추가된 부분 START
        //내가 아닌 다른 select 닫기
        label.forEach(function (itemLb) {
          if (lb !== itemLb) {
            itemLb.parentNode.classList.remove('active');
          }
        });
        //****************** 추가된 부분 END
        if (lb.parentNode.classList.contains('active')) {
          lb.parentNode.classList.remove('active');
          optionItems.forEach((opt) => {
            opt.removeEventListener('click', () => {
              handleSelect(lb, opt);
            });
          });
        } else {
          lb.parentNode.classList.add('active');
          optionItems.forEach((opt) => {
            opt.addEventListener('click', () => {
              handleSelect(lb, opt);
            });
          });
        }
      };
      var handleSelect = (label, item) => {
        this.brandName = item.textContent;
        label.parentNode.classList.remove('active');
      };
      var handleClose = e => {
        //select 가 아닌경우 닫기
        if (!e.target.classList.contains('label') && !e.target.classList.contains('optionItem')) {
          label.forEach(function (lb) {
            lb.parentNode.classList.remove('active');
          });
        }
      };
      window.addEventListener('click', e => handleClose(e));
    }
  }
};
</script>

<style scoped>
.ad_music_box .alert_mp3 {
  color: #E85454;
  font-size: 14px;
  margin-top: 6px;
}
.empty-box {
  width: calc(100% - 120px);
}

.ad_music_box .btn_area div {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.ad_music_box .btn_area div .btn_style {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 46px;
  background: #FF2D55;
  border-radius: 8px;
  cursor: pointer;
}

.ad_music_box .btn_area div .btn_style p {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  text-align: right;
  letter-spacing: -1px;
  color: #FFFFFF;
  text-decoration: none;
}

.ad_music_box .btn_area div .btn_style.close_btn {
  margin-right: 4px;
  background: none;
  transition: all .3s;
}

.ad_music_box .btn_area div .btn_style.close_btn:hover {
  background: hsla(0,0%,100%,.1);
}
</style>
